/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Reason for the ImagePromotion Ready condition.
 */
export enum ImagePromotionConditionReason {
  ImagePromotionConditionReasonWaitingForArtifacts = 'WaitingForArtifacts',
  ImagePromotionConditionReasonPublishing = 'Publishing',
  ImagePromotionConditionReasonCompleted = 'Completed',
  ImagePromotionConditionReasonFailed = 'Failed',
  ImagePromotionConditionReasonBuildFailed = 'BuildFailed',
  ImagePromotionConditionReasonBuildCanceled = 'BuildCanceled',
  ImagePromotionConditionReasonAmendmentFailed = 'AmendmentFailed',
}
